
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderInstallmentsGrid extends Serenity.EntityGrid<OrderInstallmentsRow, any> {
        protected getColumnsKey() { return OrderInstallmentsColumns.columnsKey; }
        protected getDialogType() { return OrderInstallmentsDialog; }
        protected getIdProperty() { return OrderInstallmentsRow.idProperty; }
        protected getInsertPermission() { return OrderInstallmentsRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderInstallmentsRow.localTextPrefix; }
        protected getService() { return OrderInstallmentsService.baseUrl; }

        
        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            this.editItem({ OrderId: this.OrderId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.OrderId != null;
        }

        private _OrderId: number;

        get OrderId() {
            return this._OrderId;
        }

        set OrderId(value: number) {
            if (this._OrderId != value) {
                this._OrderId = value;
                this.setEquality(OrderInstallmentsRow.Fields.OrderId, value);
                this.refresh();
            }
        }
    }
}